import { Permission } from '../enums/permission.enum';
import { Rol } from '../enums/rol.enum';

export const ROLE_PERMISSIONS: Record<Rol, Permission[]> = {
  [Rol.Admin]: [
    Permission.ManageCampaigns,
    Permission.ManageClients,
    Permission.ManageUsers,
    Permission.ManageRequests,
  ],
  [Rol.Office]: [],
  [Rol.ClientManager]: [
    Permission.ManageClients,
    Permission.ManageRequests,
  ],
  [Rol.DeclarationsManager]: [
    Permission.ManageCampaigns,
  ],
  [Rol.UsersManager]: [
    Permission.ManageUsers,
  ],
};

export function getPermissionsForRoles(roles: Rol[]): Permission[] {
  const permissions = new Set<Permission>();
  for (const role of roles) {
    const rolePerms = ROLE_PERMISSIONS[role] ?? [];
    for (const perm of rolePerms) {
      permissions.add(perm);
    }
  }
  return Array.from(permissions);
}
